import React from "react";
import { MailIcon, InstagramIcon, GlobeIcon } from "lucide-react";
export function Footer() {
  return <footer className="bg-forestDeep pb-20 text-paper md:pb-0" data-id="element-113" data-mp="3gfiswe27a3c0">
      <div className="mx-auto grid max-w-6xl gap-6 px-5 py-8 md:grid-cols-[1.5fr_1fr] md:gap-10 md:px-8 md:py-14" data-id="element-114" data-mp="32nul2myzi10u">
        <div data-id="element-115" data-mp="36p6aoshuym91">
          <p className="font-display text-xl md:text-2xl" data-id="element-116" data-mp="36ooa5jo5xlvb">Megapack de Recetas Festivas™</p>
          <p className="mt-2 max-w-lg text-[13px] leading-relaxed text-paper/65 md:mt-3 md:text-sm" data-id="element-117" data-mp="3ueimm04kl8f1">
            El sistema de recetas N°1 para anfitrionas argentinas. Porque Halloween, Navidad y Año Nuevo merecen una mesa
            que nadie olvide — y eso empieza en tu cocina.
          </p>
        </div>
        <ul className="space-y-2 text-[13px] text-paper/80 md:space-y-3 md:text-sm" data-id="element-118" data-mp="3qcnjqr6zqmz5">
          <li data-id="element-119" data-mp="29ynldknsn5e0">
            <a href="mailto:contacto@recursospracticysimple.com" className="flex items-center gap-2 transition-colors duration-150 hover:text-gold" data-id="element-120" data-mp="29y5i442prqwl">
              <MailIcon className="h-4 w-4 text-gold" aria-hidden data-id="element-121" data-mp="2evx98vvjb8zq" /> contacto@recursospracticysimple.com
            </a>
          </li>
          <li data-id="element-122" data-mp="3gaz1n2bhmjjk">
            <a href="https://instagram.com/recursospracticysimple" className="flex items-center gap-2 transition-colors duration-150 hover:text-gold" data-id="element-123" data-mp="3gbio8wc31w3x">
              <InstagramIcon className="h-4 w-4 text-gold" aria-hidden data-id="element-124" data-mp="3v5dgqrrxl8sy" /> @recursospracticysimple
            </a>
          </li>
          <li data-id="element-125" data-mp="82idhvaq8efw">
            <a href="https://recursospracticysimple.com" className="flex items-center gap-2 transition-colors duration-150 hover:text-gold" data-id="element-126" data-mp="81yvkel2tq1v">
              <GlobeIcon className="h-4 w-4 text-gold" aria-hidden data-id="element-127" data-mp="31uqrltj6jrh" /> recursospracticysimple.com
            </a>
          </li>
        </ul>
      </div>
      <p className="border-t border-paper/10 px-5 py-4 text-center text-[11px] text-paper/50 md:py-6 md:text-xs" data-id="element-128" data-mp="ctgw51j6tomb">
        © Recursos Practic &amp; Simple™ 2026 — Todos los derechos reservados.
      </p>
    </footer>;
}